@if ((loading | async) === false) {
    <div class="flex h-screen w-screen flex-col">
        <app-message-banner />
        <div class="relative flex flex-grow">
            <router-outlet />
        </div>
        <app-notification-list />
    </div>
} @else {
    <app-loading />
}
